import React from "react";
import * as z from "zod";
import "../../../assets/css/adminPages/home/stakeholders.scss";
import PageLoader from "../../../components/pageLoader";
import useStakeholders from "../../../hooks/public/useStakeholders";
import StakeholderUpdateCard from "../sections/components/StakeholderUpdateCard";
import StakeholderAddModal from "../sections/components/StakeholderAddModal";

const MAX_FILE_SIZE = 1000000;
const ACCEPTED_IMAGE_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/webp",
];

const schema = z.object({
  iconBase64: z
    .any()
    .refine((file) => file instanceof File, `Required`)
    .refine(
      (file) => ACCEPTED_IMAGE_TYPES.includes(file?.type),
      "Only .jpg, .jpeg, .png and .webp formats are supported."
    )
    .refine((file) => file?.size <= MAX_FILE_SIZE, `Max image size is 1MB.`),
  titleEn: z
    .string()
    .min(1, { message: "Required" })
    .min(3, { message: "Minimum length is 3" })
    .max(15, { message: "Max length is 15" }),
});

const StakeholdersUpdate = () => {
  const { data, isLoading, error, update, remove, create } = useStakeholders();

  if (error) return null;
  return (
    <div className="stakeholders-update-section">
      <div className="custom-container">
        <div className="content-section">
          <h1 className="page-title">Stakeholders</h1>
          <div className="content-body">
            <div className="row">
              <div className="col-12">
                <StakeholderAddModal schema={schema} onCreate={create} />
              </div>
              <div className="col-12">{isLoading && <PageLoader />}</div>
              {data.map((item) => (
                <div key={item.id} className="col-xl-3 col-lg-4 col-md-6">
                  <StakeholderUpdateCard
                    stakeholder={item}
                    schema={schema}
                    onUpdate={update}
                    onDelete={remove}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StakeholdersUpdate;
